<div class="biz-page">

    <a routerLink="/biz-directory" class="small d-inline-block mb-3">&larr; All businesses</a>

    <div *ngIf="notFound" class="rana-panel">
        <h2 class="mb-2">Listing not found</h2>
        <p class="text-muted mb-0">It may have been removed or hidden.</p>
    </div>

    <ng-container *ngIf="biz">
        <div class="alert alert-warning" *ngIf="biz.status === 'HIDDEN'">
            This listing is hidden from the directory.
            <span *ngIf="biz.hiddenReason">Reason: {{ biz.hiddenReason }}</span>
        </div>

        <div class="row">
            <!-- Main column -->
            <div class="col-lg-8">
                <!-- The business -->
                <article class="rana-panel biz-article mb-4">
                <!-- Header -->
                <div class="rana-detail-header">
                    <img *ngIf="biz.logoUrl" [src]="biz.logoUrl" class="biz-detail-logo" alt="">
                    <div *ngIf="!biz.logoUrl" class="rana-avatar rana-detail-avatar">{{ initials(biz.businessName) }}</div>
                    <div class="rana-detail-header-text">
                        <h1 class="rana-detail-title biz-title">{{ biz.businessName }}
                            <i *ngIf="biz.verified" class="uil uil-check-circle biz-verified" title="Verified by RANA"></i>
                        </h1>
                        <p class="lead mb-2" *ngIf="biz.tagline">{{ biz.tagline }}</p>
                        <div class="rana-detail-meta">
                            <span class="rana-badge rana-badge-accent">{{ category(biz.industry) }}</span>
                            <ng-container *ngIf="location"><span class="rana-detail-meta-dot">&middot;</span><span><i class="uil uil-map-marker"></i> {{ location }}</span></ng-container>
                            <ng-container *ngIf="chapterName"><span class="rana-detail-meta-dot">&middot;</span><span>{{ chapterName }} chapter</span></ng-container>
                            <ng-container *ngIf="biz.ownerName">
                                <span class="rana-detail-meta-dot">&middot;</span>
                                <span>Owner: <a *ngIf="loggedIn" [routerLink]="['/members', biz.createdBy]">{{ biz.ownerName }}</a><span *ngIf="!loggedIn">{{ biz.ownerName }}</span></span>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="rana-detail-divider"></div>

                <!-- Engagement bar -->
                <div class="biz-actions mb-4">
                    <button type="button" class="rana-action-btn mr-2 mb-1" [ngClass]="{'rana-action-btn-active': biz.likedByMe}" (click)="toggleLike()">
                        <i class="uil uil-heart"></i> {{ biz.likedByMe ? 'Liked' : 'Like' }} &middot; {{ biz.likeCount || 0 }}</button>
                    <button type="button" *ngIf="!biz.canEdit" class="rana-action-btn mr-2 mb-1" [ngClass]="{'rana-action-btn-active': biz.followedByMe}" (click)="toggleFollow()">
                        <i class="uil uil-bell"></i> {{ biz.followedByMe ? 'Following' : 'Follow' }} &middot; {{ biz.followerCount || 0 }}</button>
                    <button type="button" *ngIf="canEndorse" class="rana-action-btn mr-2 mb-1" [ngClass]="{'rana-action-btn-active': biz.endorsedByMe}" (click)="endorseOpen = !endorseOpen">
                        <i class="uil uil-thumbs-up"></i> {{ biz.endorsedByMe ? 'You recommend this' : 'I recommend this' }} &middot; {{ biz.endorsementCount || 0 }}</button>
                    <span *ngIf="!canEndorse && !biz.canEdit" class="size-13 text-muted mr-2">{{ biz.endorsementCount || 0 }} recommend{{ biz.endorsementCount === 1 ? 's' : '' }}</span>
                    <button type="button" *ngIf="!biz.canEdit" class="rana-action-btn mr-2 mb-1" (click)="startInquiry('GENERAL')">
                        <i class="uil uil-message"></i> Send a message</button>
                    <button type="button" *ngIf="!biz.canEdit && biz.mentorAvailable" class="rana-action-btn mb-1" (click)="startInquiry('MENTOR')">
                        <i class="uil uil-graduation-cap"></i> Ask for mentoring</button>
                </div>

                <div class="biz-gallery mb-4" *ngIf="biz.photos?.length">
                    <a *ngFor="let p of biz.photos" [href]="p" target="_blank" rel="noopener"><img [src]="p" alt=""></a>
                </div>

                <div class="biz-description mb-4" *ngIf="biz.description" [innerHTML]="description"></div>
                <p class="text-muted" *ngIf="!biz.description">No description provided.</p>

                <div class="mb-4" *ngIf="biz.memberOffer">
                    <div class="biz-offer"><i class="uil uil-gift"></i> <strong>RANA member offer:</strong> {{ biz.memberOffer }}</div>
                </div>
                </article>

                <div class="rana-panel mb-4" *ngIf="endorseOpen">
                    <label class="font-weight-600 size-14">Why do you recommend {{ biz.businessName }}? <span class="text-muted">(optional)</span></label>
                    <textarea class="form-control mb-2" rows="2" maxlength="300" [(ngModel)]="endorseNote" placeholder="e.g. Catered my daughter's wedding, wonderful service"></textarea>
                    <button type="button" class="btn btn-dark-primary mr-2" (click)="saveEndorsement()">{{ biz.endorsedByMe ? 'Update' : 'Recommend' }}</button>
                    <button type="button" class="rana-action-btn mr-2" (click)="endorseOpen = false">Cancel</button>
                    <button type="button" *ngIf="biz.endorsedByMe" class="rana-action-btn rana-action-btn-danger" (click)="removeEndorsement()">Remove my recommendation</button>
                </div>

                <!-- Recommendations -->
                <div class="rana-panel mb-4" *ngIf="endorsements.length">
                    <h5 class="mb-3 biz-heading">Recommended by {{ endorsements.length }} member{{ endorsements.length === 1 ? '' : 's' }}</h5>
                    <div class="biz-quote" *ngFor="let e of endorsements">
                        <div class="font-weight-500">{{ e.userName }} <small class="text-muted ml-1">{{ e.createdAtEpoch | date:'mediumDate' }}</small></div>
                        <div *ngIf="e.note">{{ e.note }}</div>
                    </div>
                </div>

                <!-- Message the owner -->
                <div class="rana-panel mb-4" id="biz-inquiry" *ngIf="!biz.canEdit && (inquirySent || inquiryText || inquiryKind === 'MENTOR' || startedInquiry)">
                    <div class="rana-panel-title">{{ inquiryKind === 'MENTOR' ? 'Ask ' + biz.ownerName + ' for mentoring' : 'Message ' + (biz.ownerName || 'the owner') }}</div>
                    <p class="size-13 text-muted">Your name and email are shared with the owner so they can reply to you.</p>
                    <p class="text-success" *ngIf="inquirySent"><i class="uil uil-check-circle"></i> Sent. The owner will reply by email.</p>
                    <ng-container *ngIf="!inquirySent">
                        <textarea class="form-control mb-2" rows="4" maxlength="2000" [(ngModel)]="inquiryText" placeholder="Write your message"></textarea>
                        <button type="button" class="btn btn-dark-primary" [disabled]="inquiryText.trim().length < 10" (click)="sendInquiry()">Send</button>
                    </ng-container>
                </div>

                <!-- Comments -->
                <div class="rana-panel mb-4">
                    <h5 class="mb-3 biz-heading">Comments ({{ biz.commentCount || 0 }})</h5>
                    <div class="biz-quote" *ngFor="let c of comments">
                        <div class="font-weight-500">{{ c.userName }}
                            <small class="text-muted ml-1">{{ c.createdAtEpoch | date:'medium' }}</small>
                            <a *ngIf="c.canDelete" href="javascript:" class="ml-2 small text-danger" (click)="deleteComment(c)">delete</a>
                        </div>
                        <div class="biz-comment-text">{{ c.text }}</div>
                    </div>
                    <p class="text-muted" *ngIf="!comments.length">No comments yet.</p>
                    <ng-container *ngIf="loggedIn; else loginToComment">
                        <textarea class="form-control mb-2" rows="3" maxlength="1000" [(ngModel)]="newComment" placeholder="Write a comment"></textarea>
                        <button type="button" class="btn btn-dark-primary" [disabled]="!newComment.trim()" (click)="postComment()">Post comment</button>
                    </ng-container>
                    <ng-template #loginToComment><p><a routerLink="/login">Log in</a> to like, comment or get in touch.</p></ng-template>
                </div>

                <!-- Owner: messages received -->
                <div class="rana-panel mb-4" *ngIf="biz.canEdit">
                    <div class="rana-panel-title">Messages sent to you ({{ inquiries.length }})</div>
                    <p class="text-muted size-13 mb-0" *ngIf="!inquiries.length">Nobody has contacted you through this listing yet.</p>
                    <div class="biz-quote" *ngFor="let i of inquiries">
                        <div class="font-weight-500">{{ i.senderName }}
                            <span class="rana-badge rana-badge-accent ml-1" *ngIf="i.kind === 'MENTOR'">Mentoring</span>
                            <small class="text-muted ml-1">{{ i.createdAtEpoch | date:'medium' }}</small></div>
                        <div class="biz-comment-text">{{ i.message }}</div>
                        <a *ngIf="i.senderEmail" [href]="'mailto:' + i.senderEmail" class="size-13">{{ i.senderEmail }}</a>
                    </div>
                </div>
            </div>

            <!-- Side column -->
            <div class="col-lg-4">
                <div class="rana-panel mb-3">
                    <div class="rana-panel-title">Details</div>
                    <dl class="biz-facts">
                        <ng-container *ngIf="biz.serviceArea"><dt>Serves</dt><dd>{{ areaLabel(biz.serviceArea) }}</dd></ng-container>
                        <ng-container *ngIf="biz.size"><dt>Team</dt><dd>{{ sizeLabel(biz.size) }}</dd></ng-container>
                        <ng-container *ngIf="biz.yearStarted"><dt>Started</dt><dd>{{ biz.yearStarted }}</dd></ng-container>
                        <ng-container *ngIf="biz.lookingFor?.length"><dt>Looking for</dt>
                            <dd><span class="biz-tag" *ngFor="let l of biz.lookingFor">{{ lookingFor(l) }}</span></dd></ng-container>
                        <ng-container *ngIf="biz.offerings?.length"><dt>Offers</dt>
                            <dd><span class="biz-tag" *ngFor="let t of biz.offerings">{{ t }}</span></dd></ng-container>
                    </dl>
                    <div class="biz-mentor" *ngIf="biz.mentorAvailable">
                        <i class="uil uil-graduation-cap"></i> Happy to mentor members starting a similar business
                    </div>
                </div>

                <div class="rana-panel mb-3">
                    <div class="rana-panel-title">Contact</div>
                    <a *ngIf="biz.website" [href]="biz.website" target="_blank" rel="noopener" class="biz-contact-row" (click)="trackWebsiteClick()">
                        <i class="uil uil-globe"></i> {{ biz.website }}</a>
                    <ng-container *ngIf="!biz.contactHidden">
                        <a *ngIf="biz.phone" [href]="'tel:' + biz.phone" class="biz-contact-row"><i class="uil uil-phone"></i> {{ biz.phone }}</a>
                        <a *ngIf="biz.email" [href]="'mailto:' + biz.email" class="biz-contact-row"><i class="uil uil-envelope"></i> {{ biz.email }}</a>
                        <a *ngIf="biz.whatsapp" [href]="whatsappLink" target="_blank" rel="noopener" class="biz-contact-row"><i class="uil uil-whatsapp"></i> WhatsApp</a>
                        <a *ngIf="biz.linkedin" [href]="biz.linkedin" target="_blank" rel="noopener" class="biz-contact-row"><i class="uil uil-linkedin"></i> LinkedIn</a>
                        <a *ngIf="biz.instagram" [href]="biz.instagram" target="_blank" rel="noopener" class="biz-contact-row"><i class="uil uil-instagram"></i> Instagram</a>
                        <a *ngIf="biz.facebook" [href]="biz.facebook" target="_blank" rel="noopener" class="biz-contact-row"><i class="uil uil-facebook"></i> Facebook</a>
                        <p class="text-muted size-13 mb-0" *ngIf="!hasContact && !biz.website">The owner has not added contact details yet.</p>
                    </ng-container>
                    <p class="size-13 mb-0 mt-2" *ngIf="biz.contactHidden">
                        <i class="uil uil-lock-alt"></i> <a routerLink="/login">Log in</a> to see phone, email and social links.
                    </p>
                </div>

                <div class="rana-panel mb-3">
                    <div class="rana-panel-title">Share</div>
                    <button type="button" class="rana-action-btn mr-2" (click)="copyLink()"><i class="uil uil-link"></i> Copy link</button>
                    <a class="rana-action-btn" [href]="whatsappShare" target="_blank" rel="noopener"><i class="uil uil-whatsapp"></i> WhatsApp</a>
                </div>

                <div class="rana-panel mb-3" *ngIf="biz.canEdit">
                    <div class="rana-panel-title">How your listing is doing</div>
                    <dl class="biz-facts">
                        <dt>Page views</dt><dd>{{ biz.viewCount || 0 }}</dd>
                        <dt>Website clicks</dt><dd>{{ biz.clickCount || 0 }}</dd>
                        <dt>Inquiries</dt><dd>{{ biz.inquiryCount || 0 }}</dd>
                        <dt>Endorsements</dt><dd>{{ biz.endorsementCount || 0 }}</dd>
                        <dt>Followers</dt><dd>{{ biz.followerCount || 0 }}</dd>
                    </dl>
                </div>
            </div>
        </div>

        <!-- Owner / moderator actions -->
        <div class="rana-detail-actions biz-actions-bar" *ngIf="biz.canEdit || biz.canModerate">
            <a *ngIf="biz.canEdit" class="rana-action-btn" [routerLink]="['/biz-directory', biz.id, 'edit']"><i class="uil uil-edit"></i> Edit</a>
            <button *ngIf="biz.canModerate" type="button" class="rana-action-btn" (click)="toggleVerified()">
                <i class="uil uil-check-circle"></i> {{ biz.verified ? 'Remove verification' : 'Mark verified' }}</button>
            <button *ngIf="biz.canModerate" type="button" class="rana-action-btn" (click)="toggleHidden()">
                <i class="uil uil-eye-slash"></i> {{ biz.status === 'HIDDEN' ? 'Unhide' : 'Hide' }}</button>
            <button *ngIf="biz.canEdit || biz.canModerate" type="button" class="rana-action-btn rana-action-btn-danger" (click)="deleteBusiness()">
                <i class="uil uil-trash-alt"></i> Delete</button>
        </div>

        <!-- Similar businesses -->
        <div class="mt-4" *ngIf="similar.length">
            <h5 class="mb-3 biz-heading">Similar businesses</h5>
            <div class="row">
                <div class="col-md-6 col-xl-4 mb-3" *ngFor="let s of similar">
                    <app-biz-card [biz]="s"></app-biz-card>
                </div>
            </div>
        </div>
    </ng-container>
</div>
